const LOGIN_URL = "/api/token/";
const LOGOUT_URL = "/api/logout/";
const SLIDE_URL = "/api/slide/";
const SLIDES_URL = "/api/slides/";
const SLIDES_DELETE_URL = "/api/slides/delete/";
const SLIDES_REPORT_URL = "/api/slides/report/";
const ICD10_URL = "/api/icd-10/";
const ORGANIZATION_URL = "/api/organization/";
const ANNOTATION_URL = "/api/annotation/";
const EXPORT_URL = "/api/export-slide/";
const USER_URL = "/api/employee/"
const PROCESS_URL = "https://patob.fcpriirf.ru/process/"
const FAVORITES_URL = "/api/favorites/";

export {
    LOGIN_URL,
    LOGOUT_URL,
    SLIDE_URL,
    SLIDES_URL,
    SLIDES_DELETE_URL,
    SLIDES_REPORT_URL,
    ICD10_URL,
    ORGANIZATION_URL,
    ANNOTATION_URL,
    EXPORT_URL,
    USER_URL,
    PROCESS_URL,
    FAVORITES_URL,
};
